export default {
    ADD_TO_CART_ERROR: "PRODUCT.ADD_TO_CART",
    AVAILABILITY_REMINDER_LAYER_CHANGED: "PRODUCT.AVAILABILITY_REMINDER_LAYER",
    BENEFIT_ITEM_HIDE_IF_MISSING: "PRODUCT.BENEFIT_ITEM_HIDE_IF_MISSING",
    BOTTOM_DRAWER_DISABLE: "PRODUCT.BOTTOM_DRAWER_DISABLE",
    BOTTOM_DRAWER_ENABLE: "PRODUCT.BOTTOM_DRAWER_ENABLE",
    CHANGED: "PRODUCT.CHANGED",
    DISABLE_SLIDER: "PRODUCT.DISABLE_SLIDER",
    IMAGES: "PRODUCT.IMAGES",
    IMAGE_CHANGED: "PRODUCT.IMAGE_CHANGED",
    OPEN_SIDE_SHEET_FOR_SOLD_OUT_ARTICLE: "PRODUCT.OPEN_SIDE_SHEET_FOR_SOLD_OUT_ARTICLE",
    OPEN_SIDE_SHEET_FOR_REVIEWS: "PRODUCT.OPEN_SIDE_SHEET_FOR_REVIEWS",
    REVIEWS_SHOW_MORE: "PRODUCT.REVIEWS_SHOW_MORE",
    REVIEWS_FILTER: "PRODUCT.REVIEWS_FILTER",
    REVIEWS_FILTER_REMOVE: "PRODUCT.REVIEWS_FILTER_REMOVE",
    REVIEWS_FILTER_REMOVE_ALL: "PRODUCT.REVIEWS_FILTER_REMOVE_ALL",
    REVIEWS_COUNT: "PRODUCT.REVIEWS_COUNT",
    REVIEWS_SORTING: "PRODUCT.REVIEWS_SORTING",
    REVIEW_FEEDBACK: "PRODUCT.REVIEW_FEEDBACK",
    REVIEW_REPORT: "PRODUCT.REVIEWS_REPORT",
    REVIEW_REPORTED_ID: "PRODUCT.REVIEWS_REPORTED_ID",
    SELECTION_NEEDED: "PRODUCT.SELECTION_NEEDED",
    SHOW_SUBMIT_ERROR: "PRODUCT.SHOW_SUBMIT_ERROR",
    HIDE_SUBMIT_ERROR: "PRODUCT.HIDE_SUBMIT_ERROR",
    SCROLL_TO_REVIEWS: "PRODUCT.SCROLL_TO_REVIEWS"
};
